<template>
    <section class="edit-fileds">
        <section class="edit-fileds__name-wrapper">
            <label class="edit-fileds__label">{{$t('com.file.edit-announcement.name')}}</label>
            <input type="text"
                   :placeholder="$t('com.file.edit-announcement.input-name-placeholder')"
                   v-model="name"
                   class="edit-fileds__input"
                   v-error="{ errors, input_key: 'name' }" /> 
            <ErrorMessage v-if="isError('name', this.errors)" :errorMsgs="passErrorMsg('name', this.errors)" />
            <CharactersCounter :text="name" maxLenght=350 />
        </section>
        
        <section class="edit-fileds__bottom">
            
            <button class="edit-fileds__bottom-button" @click="this.$emit('closeEdit')"> {{$t('com.global.cancel')}} </button>
            <button :disabled="name.length == 0 || name.length > 350" class="edit-fileds__bottom-button edit-fileds__bottom-button--red" @click="handleSaveClick"> {{$t('com.global.save')}} </button>
        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script charset="utf-8">
    import LoaderInside from "@/components/BasicControls/LoaderInside.vue";
    import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
    import AttachmentService from "@/services/attachments.service";
    import CharactersCounter from "@/components/BasicControls/CharactersCounter.vue"

    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "@/formValidation/main";

    export default {
        name: "EditAttachment",
        data() {
            return {
                name: this.attachmentName,
                editor: null,
                isLoading: false,
                storedNoteData: {},
                errors: [],
                isPublic: false
            };
        },
        components: {
            LoaderInside,
            ErrorMessage,
            CharactersCounter
        },
        props: {
            attachmentID: Number,
            elemID: Number,
            attachmentName: String
        },
        methods: {
            handleSaveClick() {
                this.isLoading = true;
                this.errors = [];
           
                const data = {
                    id: this.attachmentID,
                    name: this.name,
                };
                AttachmentService.updateAnnouncementFile(this.attachmentID, this.elemID, data)
                    .then(() => {
                        var d = {
                            elemId: this.elemID,
                            fileId: this.attachmentID,
                            name: this.name
                        };
                        this.$emit("reload", d);
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        this.errors = setErrors(err);
                    });
            },
            passErrorMsg,
            isError,
            setErrors,
        }
    };
</script>

<style lang="scss" scoped>
    .edit-fileds {
        &__name-wrapper {
            padding: 0px 16px 8px 16px;
            display: flex;
            flex-direction: column;
            padding-top: 15px;
            border-top: 1px solid #dde0e7;
        }

        &__text {
            padding: 0px 16px 8px 16px;
            display: flex;
            flex-direction: column;
            padding-top: 18px;
        }

        &__label {
            font-weight: 600;
            font-size: 14px;
            line-height: 145%;
            margin-bottom: 6px;
            color: #00082c;
        }

        &__input {
            height: 48px;
            padding: 8px 16px 8px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 16px;
            line-height: 144%;
            color: #00082c;

            &:focus {
                border: 1px solid #00082c;
            }
        }

        &__bottom {
            padding: 0px 16px 8px 16px;
            display: flex;
            justify-content: space-between;
            margin-top: 16px;
        }

        &__bottom-button {
            padding: 0;
            width: 225px;
            height: 46px;
            background: #ffffff;
            border: 1px solid #bbc2ce;
            box-sizing: border-box;
            border-radius: 4px;
            font-weight: 500;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
            margin-bottom: 18px;
            transition: all 0.2s ease-in-out;
            background: #e8ebef;

            &--red {
                border: 0px;
                background: #d80418;
                color: white;
                transition: all 0.2s ease-in-out;

                &:hover {
                    background: #ad0313;
                }
            }

            &--red:disabled {
                border: 0px;
                background: #D3D3D3;
                color: white;
                cursor: default;
            }
        }

        &__wyswig {
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            border-radius: 4px;
            height: 213px;
            max-height: 213px;
            max-width: 468px;
        }
    }
</style>

<style lang="scss" scope>
    .ProseMirror {
        border-top: 1px solid #dde0e7;
        max-height: 144px !important;
        overflow-y: auto;
        padding: 12.5px 16px;

        &::-webkit-scrollbar {
            width: 12px;
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #b5b8bd;
            border-radius: 30px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #b5b8bd;
        }

        &::-webkit-scrollbar-track {
            background: #ffffff;
            border: 0.8px solid #dce4ee;
            border-radius: 30px;
            box-shadow: inset 0px 0px 0px 0px #f0f0f0;
        }

        &:focus {
            outline: none;
        }
    }

.wyswig-actions {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 5px;

    &__btn {
        border-radius: 5px;
        width: 21px;
        height: 21px;
        background-color: transparent;
        border: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__icon {
        widows: 13px;
        height: 13px;
    }
}

    .switch-section {
        padding: 0px 16px 8px 16px;
        display: flex;
        margin-bottom: 0px;
        margin-top: 10px;
    }

    .tooltip {
        position: relative;
        left: 5px;
        top: -3px;
    }

    .tip-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0px;
        background-color: transparent;
        width: 20px;
        height: 20px;
        position: relative;
        cursor: pointer;

        &:hover .hint {
            opacity: 1;
            display: block;
        }
    }
</style>
